"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useResize = void 0;
var react_1 = require("react");
var lodash_1 = require("lodash");
var useEventListener_1 = require("./useEventListener");
var useResize = function (callback, wait, method) {
    if (wait === void 0) { wait = 250; }
    var methodFn = method === "debounce" ? lodash_1.debounce : lodash_1.throttle;
    var handleResize = (0, react_1.useMemo)(function () {
        return wait !== 0
            ? methodFn(function (event) { return callback(event); }, wait, {
                leading: false,
                trailing: true,
            })
            : function (event) { return callback(event); };
    }, [wait, callback, methodFn]);
    (0, useEventListener_1.useEventListener)({
        type: "resize",
        listener: handleResize,
    });
};
exports.useResize = useResize;
